<div class="card min-h-[210px] bg-primary text-white rounded-xl hover:cursor-pointer p-4 text-center h-full">
    <div style="position: relative;"
        class="border-b-2 py-5 border-white flex justify-center items-center  position-relative">
        <img width="50px" [src]="subject().icon" alt="">
    </div>
    <div style="position: relative;" class="w-24 rounded-2xl h-2 bg-[#00EED0] position-absolute bottom-1 left-0">

    </div>

    <h3 class="font-bold text-lg my-2">{{subject().name}}</h3>
    <p>{{subject().discrption}}</p>

</div>